export default class Avaliador {

    constructor(pessoa={}, tipo={}, lotacao={}) {
        this.pessoa = pessoa;
        this.tipo = tipo;
        this.lotacao = lotacao;
    }
}


// WEBPACK FOOTER //
// ./src/domain/avaliador/index.js